import { ContinueButton } from '../continue_button'
import { Stack, TextField, Typography } from '@mui/material'
import { FormikProps } from 'formik'
import { TFormikValues } from './signin_tooltip_content'
import { i18WithDefault as t } from '@shared/locales'

type EnterEmailFormProps = {
  formik: FormikProps<TFormikValues>
}

export const EnterEmailForm = ({ formik }: EnterEmailFormProps) => (
  <Stack spacing={2}>
    <Stack key="email-view">
      <Typography variant="body2" textAlign="center">
        {t('signin.enterEmail.title')}
      </Typography>
      <Typography variant="caption" textAlign="center">
        {t('signin.enterEmail.copy')}
      </Typography>
    </Stack>
    <TextField
      key="email"
      name="email"
      value={formik.values.email}
      placeholder={t('signin.enterEmail.email')}
      size="small"
      onChange={formik.handleChange}
      error={formik.touched.email && Boolean(formik.errors.email)}
      helperText={formik.touched.email && formik.errors.email}
      FormHelperTextProps={{ sx: { height: 'auto' } }}
    />
    <ContinueButton type="submit" loading={formik.isSubmitting} />
  </Stack>
)
